import { render, staticRenderFns } from "./ItemScL.vue?vue&type=template&id=1fdfb536"
import script from "./ItemScL.vue?vue&type=script&lang=js"
export * from "./ItemScL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports